import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { addVideo } from '../../action/video.actions';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-add-videos',
  templateUrl: './add-videos.component.html',
  styleUrl: './add-videos.component.scss'
})
export class AddVideosComponent {
  videoForm: FormGroup;
  categories = ['Blog', 'Video', 'Podcast']; // Modify categories if needed
  keywordInput: string = '';  // Temporary input value
  keywordsArray: string[] = [];


  languageSelected: string = 'english';


  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store:Store,
    private snackBar: MatSnackBar
  ) {
    this.videoForm = this.fb.group({
      id:"",
      keywords:"",
      keywords1:"",
      seotitle:"",
      seodescription:"",
      more_description:"",
      seo_url:"",
      cta_button_enabled:[false],
      togglecontrol:[false],
      cta_button_text:[''],
      cta_button_link:[''],
      cta_button_source_name:[''],
      title: ['', Validators.required],
      description: ['', Validators.required],
      category: ['', Validators.required],
      publishdate: ['', Validators.required],
      videolink: ['', Validators.required],




      //For French
      idfr:"",
      keywordsfr:"",
      keywords1fr:"",
      seotitlefr:"",
      seodescriptionfr:"",
      more_descriptionfr:"",
      seo_urlfr:"",
      cta_button_enabledfr:[false],
      togglecontrolfr:[false],
      cta_button_textfr:[''],
      cta_button_linkfr:[''],
      cta_button_source_namefr:[''],
      titlefr: ['', Validators.required],
      descriptionfr: ['', Validators.required],
      categoryfr: ['', Validators.required],
      publishdatefr: ['', Validators.required],
      videolinkfr: ['', Validators.required],




      //For spanish
      idsp:"",
      keywordssp:"",
      keywords1sp:"",
      seotitlesp:"",
      seodescriptionsp:"",
      more_descriptionsp:"",
      seo_urlsp:"",
      cta_button_enabledsp:[false],
      togglecontrolsp:[false],
      cta_button_textsp:[''],
      cta_button_linksp:[''],
      cta_button_source_namesp:[''],
      titlesp: ['', Validators.required],
      descriptionsp: ['', Validators.required],
      categorysp: ['', Validators.required],
      publishdatesp: ['', Validators.required],
      videolinksp: ['', Validators.required],



      //For portuguese
      idpr:"",
      keywordspr:"",
      keywords1pr:"",
      seotitlepr:"",
      seodescriptionpr:"",
      more_descriptionpr:"",
      seo_urlpr:"",
      cta_button_enabledpr:[false],
      togglecontrolpr:[false],
      cta_button_textpr:[''],
      cta_button_linkpr:[''],
      cta_button_source_namepr:[''],
      titlepr: ['', Validators.required],
      descriptionpr: ['', Validators.required],
      categorypr: ['', Validators.required],
      publishdatepr: ['', Validators.required],
      videolinkpr: ['', Validators.required],
    });
    console.log(data,'datadata')
    this.videoForm.patchValue(data.video);
  }

  setLanguage(lang: string) {
    this.languageSelected = lang;
  }

  saveVideo() {
    // if (this.videoForm.valid) {
       this.store.dispatch(addVideo({ video:this.videoForm.value }));
            this.snackBar.open('Blog added successfully!', 'Close', { duration: 3000 });
            this.dialogRef.close();
      // this.dialogRef.close(this.videoForm.value);
    // }
  }

  close() {
    this.dialogRef.close();
  }
  addKeyword() {

    const trimmedKeyword = this.videoForm.get('keywords1').value.trim();
    if (trimmedKeyword && !this.keywordsArray.includes(trimmedKeyword)) {
      this.keywordsArray.push(trimmedKeyword);
      this.updateKeywordsField();
    }
    this.keywordInput = ''; // Clear input
    this.videoForm.get('keywords1').setValue('')
  }

  // Remove a keyword and update FormControl
  removeKeyword(index: number) {
    this.keywordsArray.splice(index, 1);
    this.updateKeywordsField();
  }

  // Update the FormControl with concatenated keywords
  private updateKeywordsField() {
    this.videoForm.patchValue({ keywords: this.keywordsArray.join(',') });
  }
  toggleAction() {
    this.videoForm.get('togglecontrol')?.setValue(!this.videoForm.get('togglecontrol')?.value);
  }
}
